import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, ChevronDown, List, MessageCircle } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { useIsMobile } from '../hooks/useIsMobile';
import { colors } from '../styles/tokens';

export default function Header({ subtitle = 'Cotações', userName = 'Usuário' }) {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await logout();
  };

  return (
    <header style={{
      backgroundColor: colors.primary,
      borderBottom: `1px solid ${colors.primary}`,
      position: 'sticky',
      top: 0,
      zIndex: 50
    }}>
      <div style={{
        maxWidth: '1280px',
        margin: '0 auto',
        padding: isMobile ? '0.75rem 1rem' : '1rem 1.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '0.75rem' : '1.5rem' }}>
          <h1
            style={{ fontSize: isMobile ? '1.1rem' : '1.25rem', fontWeight: 600, color: colors.white, cursor: 'pointer', margin: 0 }}
            onClick={() => navigate('/app')}
          >
            DSC Travel
          </h1>
          {!isMobile && (
            <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem' }}>
              {subtitle}
            </span>
          )}
        </div>

        <div
          ref={menuRef}
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
          }}
        >
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '0.25rem'
            }}
          >
            {!isMobile && (
              <span style={{ fontSize: '0.875rem', color: colors.white }}>
                {userName}
              </span>
            )}
            <div style={{
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              backgroundColor: colors.accent,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: colors.white,
              fontWeight: 600,
              fontSize: '0.875rem'
            }}>
              {userName.charAt(0).toUpperCase()}
            </div>
            <ChevronDown
              size={16}
              color="rgba(255,255,255,0.7)"
              style={{
                transform: menuOpen ? 'rotate(180deg)' : 'rotate(0)',
                transition: 'transform 0.2s'
              }}
            />
          </button>

          {menuOpen && (
            <div style={{
              position: 'absolute',
              top: '100%',
              right: 0,
              marginTop: '0.5rem',
              backgroundColor: colors.card,
              borderRadius: '0.5rem',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
              border: `1px solid ${colors.border}`,
              minWidth: '180px',
              overflow: 'hidden',
              zIndex: 100
            }}>
              <button
                onClick={() => {
                  setMenuOpen(false);
                  navigate('/app/dashboard');
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  padding: '0.75rem 1rem',
                  fontSize: '0.875rem',
                  color: colors.text,
                  background: 'transparent',
                  border: 'none',
                  width: '100%',
                  textAlign: 'left',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = colors.background}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                <List size={18} color={colors.text} />
                Minhas Cotações
              </button>
              <button
                onClick={() => {
                  setMenuOpen(false);
                  navigate('/app/conversas');
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  padding: '0.75rem 1rem',
                  fontSize: '0.875rem',
                  color: colors.text,
                  background: 'transparent',
                  border: 'none',
                  width: '100%',
                  textAlign: 'left',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = colors.background}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                <MessageCircle size={18} color={colors.text} />
                Conversas
              </button>
              <div style={{ height: '1px', backgroundColor: colors.border }} />
              <button
                onClick={handleLogout}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  padding: '0.75rem 1rem',
                  fontSize: '0.875rem',
                  color: '#dc2626',
                  background: 'transparent',
                  border: 'none',
                  width: '100%',
                  textAlign: 'left',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fef2f2'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                <LogOut size={18} color="#dc2626" />
                Sair
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
